import { useState } from "react";
import { Redirect, Route, Switch, useHistory } from "react-router-dom";
import { Tab } from "types/generic";

type ContentLayoutProps = {
    title: React.ReactNode;
    tabs: Tab[];
    showTabs?: boolean;
    metadata?: any;
    setMetadata?: (metadata: any) => void;
    subHeaderOverlay?: JSX.Element;
};

const ContentLayout = ({
    title,
    tabs,
    showTabs = true,
    metadata,
    setMetadata,
    subHeaderOverlay,
}: ContentLayoutProps) => {
    const history = useHistory();

    const [selectedTab, setSelectedTab] = useState<string>(
        tabs.length > 0 ? tabs[0].id : "default"
    );

    const getSelectedTabId = () => {
        let currentPath: string[] = history.location.pathname
            .split("/")
            .splice(1);

        if (currentPath.length >= 3 && tabs.length > 0) {
            return currentPath[2];
        }
    };

    const getSelectedTabContent = () => {
        for (let index in tabs) {
            const currentTab = tabs[index];
            if (currentTab.id === selectedTab) {
                return currentTab.content();
            }
        }
    };

    const generateRoutesForTabs = () => (
        <Switch>
            {tabs.map((tab: Tab) => {
                return (
                    <Route
                        path={"/:layout/:page/" + tab.id}
                        render={() => {
                            return tab.content();
                        }}
                        key={`tab_${tab.id}`}
                    />
                );
            })}
            <Redirect
                from="/administration/home/*"
                to="/administration/home/"
            />
            <Redirect
                from="/administration/hierarchy/*"
                to="/administration/hierarchy/"
            />
            <Redirect
                from="/administration/users/*"
                to="/administration/users/"
            />
            <Redirect from="/administration/gis/*" to="/administration/gis/" />
        </Switch>
    );

    const areTabsDisplayed = () => {
        return tabs && tabs.length > 0 && showTabs;
    };

    const generateTabs = () => {
        // Remove the first entry, since it will be always empty due to the split
        let currentPath: string[] = history.location.pathname
            .split("/")
            .splice(1)
            .filter((path) => path !== "");
        let layoutRoute: string = currentPath[0];
        let pageRoute: string = currentPath[1];

        // TODO: Find if the tab really exists between the tabs
        if (currentPath.length <= 2 && tabs.length > 0) {
            // This NEEDS to stay as a replace. Otherwise, navigation is fractured
            // cause of a redirect caused from the push.
            history.replace(`/${layoutRoute}/${pageRoute}/${tabs[0].id}`);
        }

        if (areTabsDisplayed()) {
            const tabList = tabs.map((tab: Tab) => {
                return (
                    <div
                        className={
                            "c-sub-header-tab" +
                            (tab.id === getSelectedTabId() ? " --active" : "")
                        }
                        onClick={() =>
                            history.push(
                                `/${layoutRoute}/${pageRoute}/${tab.id}`
                            )
                        }
                        key={"id_" + tab.id}
                    >
                        {tab.title}
                    </div>
                );
            });
            return <div className="l-content-layout__tabs">{tabList}</div>;
        } else {
            return null;
        }
    };

    return (
        <div className="l-content-layout">
            <div
                className={
                    "l-content-layout__sub-header " +
                    (areTabsDisplayed() ? "--enabled-tabs" : "")
                }
            >
                <div className="l-content-layout__title">{title}</div>
                {generateTabs()}
            </div>
            <div
                className={
                    "l-content-layout__main-content " +
                    (areTabsDisplayed() ? "--enabled-tabs" : "")
                }
            >
                {generateRoutesForTabs()}
            </div>
        </div>
    );
};

export default ContentLayout;
